<template>
  <b-card>
    <b-row>
      <b-col>
        <b-form-group
          label="Parametre Grubu"
          label-for="param_sub_groups"
        >
          <v-select
            id="param_sub_groups"
            v-model="filterData.param_sub_groups"
            :options="paramGroups"
            label="notes"
            :reduce="item => item.param_sub_groups"
            placeholder="Parammetre Grubu"
            @input="getDataList"
          >
            <template v-slot:option="option">
              <div class="font-weight-bold">
                {{ option.notes }}
              </div>
              <div class="font-small-2 text-warning">
                {{ option.param_groups }}
              </div>
              <div class="font-small-2 text-muted">
                {{ option.param_sub_groups }}
              </div>
            </template>
          </v-select>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group
          label="Proje"
          label-for="id_projects"
        >
          <v-select
            id="id_projects"
            v-model="filterData.id_projects"
            :options="projects"
            label="title"
            :reduce="item => item.id"
            placeholder="Proje"
            @input="getDataList"
          />
        </b-form-group>
      </b-col>
    </b-row>
  </b-card>
</template>
<script>
import {
  BCard, BRow, BCol, BFormGroup,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  name: 'FilterCard',
  components: {
    BCard,
    BRow,
    BCol,
    BFormGroup,
    vSelect,
  },
  props: {
    getDataList: {
      type: Function,
      required: true,
    },
  },
  computed: {
    paramGroups() {
      return this.$store.getters['paramSchemes/paramGroups']
    },
    projects() {
      return this.$store.getters['projects/dataList']
    },
    filterData() {
      return this.$store.getters['params/filterData']
    },
  },
  created() {
    this.getParamGroups()
    this.getProjects()
  },
  methods: {
    getParamGroups() {
      this.$store.dispatch('paramSchemes/getParamGroups')
    },
    getProjects() {
      this.$store.dispatch('projects/getDataList')
    },
  },
}
</script>
